import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum PersonSupportMeasureEnum {
    DECISION_HELP = "decisionHelp",
    REPRESENTED_BY = "representedBy",
}

export const personSupportMeasureEnumOptions = enumToOptions(PersonSupportMeasureEnum, 'person.enum.supportMeasure.');
